import _ from "lodash";
import { measureFromEnum } from "./constants";
import { store } from "../../../redux/store";
import { UpdatedApproachViews } from "./helpers";

export const createCenterOfGreen = (
  hole,
  element,
  greensDescriptions,
  ezLocator
) => {
  let state = store.getState();
  let viewMeasureFromReduxState = state.firstReducer.viewMeasureFromReduxState;
  let viewMeasurement = state.firstReducer.activeMeasurementButtonReduxState;
  let activeMarker = state.secondReduces.selectedMeasurementPinReduxState;

  let centerOfGreenActive = function () {
    return activeMarker === "cog";
  };
  let cog = _.filter(hole.PoiData, { Name: "CenterOfGreen" })[0];

  function activeRotation() {
    if (greensDescriptions.RotationSets.length !== 0) {
      var active = _.filter(
        _.flatten(greensDescriptions.RotationSets, "Rotations"),
        "Active"
      );
      if (active.length === 1) {
        return active[0];
      }
    }
    return null;
  }

  function activePinDisplayed(hole) {
    let displayed = false;
    let active = activeRotation();
    if (active !== null) {
      var pp = _.filter(hole.PinPlacements, { Name: active.Marker });
      if (pp.length === 1) {
        if (pp[0].X !== 0 || pp[0].Y !== 0) displayed = true;
      }
    }
    return displayed;
  }
  if (cog.Longitude === 0 && cog.Latitude === 0) {
    // No center of green has been defined.
    // This is OK.  DualPin support has secondary courses where not all
    // holes have two pins.  In that situation, the primary course's hole
    // has a COG but the secondary course's hole does not.
    //return;
  }

  let cogOnView = hole.worldToImage.transformPoint(cog.Longitude, cog.Latitude);
  cogOnView = hole.viewToGreen.transformPoint(cogOnView[0], cogOnView[1]);
  hole.cog = { x: cogOnView[0], y: cogOnView[1] };

  function setAttributes(el, attrs) {
    for (var key in attrs) {
      el.setAttributeNS(null, key, attrs[key]);
    }
  }

  function addClassSvg(el, cl) {
    var curr = el.getAttribute("class");

    if (curr === null || curr.indexOf(cl) === -1) {
      el.setAttribute("class", _([el.getAttribute("class"), cl]).join(" "));
    }
  }

  // TODO -- This needs to be uncommented when "EzLocatorCourseId" works
  //  if (!dcCrs.EzLocatorCourseId) {
  if (!ezLocator) {
    // Skip these items if ezLocator integrated
    var cogImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image"
    );
    addClassSvg(cogImage, "cog");

    // Test View To World transform
    //var ptCogWorldFromImage = hole.imageToWorld.transformPoint(cog.Longitude, cog.Latitude)
    //var ptCogWorldFromGreen = hole.greenToWorld.transformPoint(cogOnView[0], cogOnView[1]);

    // Subtract 1/2 width and height to center the image since it is drawn from upper left corner
    setAttributes(cogImage, {
      x: cogOnView[0] - 8,
      y: cogOnView[1] - 8,
      width: 16,
      height: 16,
    });
    // Save the original values for reference when defining arrows.
    cogImage.setAttribute("location", JSON.stringify(hole.cog));
    cogImage.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "xlink:href",
      require("../../../assets/Content/images/CoG16x16.png")
    );
    //  cogImage.setAttributeNS('http://www.w3.org/1999/xlink', 'src', require('../../../assets/Content/images/CoG16x16.png'));

    if (
      viewMeasurement &&
      viewMeasureFromReduxState === measureFromEnum.center
    ) {
      //  addClassSvg(cogImage, 'onlyPrint');
    } else if (!centerOfGreenActive() && activePinDisplayed(hole)) {
      addClassSvg(cogImage, "hide");
    }
    element.appendChild(cogImage);
  }
  let holeIndex = UpdatedApproachViews.findIndex(
    (item) => item.Hole === hole.HoleNumber
  );
  if (holeIndex > -1) {
    UpdatedApproachViews.splice(holeIndex, 1);
  }
  UpdatedApproachViews.push(hole);
};
